import React, { useState } from 'react';
import './TabMenu.scss';
import PropTypes from 'prop-types';
import MaterialIcon from '@material/react-material-icon';

const TabMenu = ({ countData, selectedTab, setSelectedTab, menus }) => {
  const [showMenu, setShowMenu] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState('');

  return (
    <div className="tab-menu">
      <div className={`content-tab-menu ${showMenu ? 'active' : ''}`}>
        {menus?.map((menu) => (
          <div
            key={menu.id}
            className={selectedTab === menu.id ? 'active' : ''}
            onClick={() => {
              setSelectedTab(menu.id);
              setShowMenu(false);
              setSelectedMenu(menu.name);
            }}
          >
            <MaterialIcon className="my-icon" icon={menu.icon} />
            {menu.name}
            {menu.badge && countData > 0 && <div className="ready" />}
          </div>
        ))}
      </div>

      <div className="btn-menu" onClick={() => setShowMenu(!showMenu)}>
        <span>{selectedMenu}</span>
        {showMenu ? <MaterialIcon icon="close" /> : <MaterialIcon icon="menu" />}
      </div>
    </div>
  );
};

TabMenu.propTypes = {
  countData: PropTypes.number,
  selectedTab: PropTypes.number,
  setSelectedTab: PropTypes.func,
  menus: PropTypes.array,
};

export default TabMenu;
